import CustomChip from '@/components/chip/CustomChip';
import EntityDetailButton from '@/components/entity-detail/components/Button';
import HoverCopyCell from '@/components/table-data-grid/HoverCopyCell';
import type { TableColumnConfig } from '@/types/common/table-config.type';
import { RoleEnum } from '@/types/enums/role.enum';
import { dateUtils } from '@/utils/date';

export const columns = (columnParams: any): TableColumnConfig[] => [
    {
        field: 'errorDetailCode',
        headerName: 'Mã lỗi',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.errorDetail?.code} />
        ),
    },
    {
        field: 'errorDetailName',
        headerName: 'Tên lỗi',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.errorDetailName} />
        ),
    },
    {
        field: 'errorType',
        headerName: 'Loại sự cố',
        editable: false,
        sortable: false,
        minWidth: 200,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.errorType?.name} />
        ),
    },
    {
        field: 'customer',
        headerName: 'Khách hàng',
        editable: false,
        sortable: false,
        minWidth: 300,
        flex: 1,
        renderCell: params => (
            <HoverCopyCell value={params.row.taskCheck?.ticket?.customer?.name}>
                <EntityDetailButton
                    text={params.row.taskCheck?.ticket?.customer?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.ticket?.customer?.id}
                    type='CUSTOMER'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.CUSTOMER],
    },
    {
        field: 'deviceName',
        headerName: 'Thiết bị',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 300,
        renderCell: params => (
            <HoverCopyCell value={params.row.taskCheck?.device?.name}>
                <EntityDetailButton
                    text={params.row.taskCheck?.device?.name}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.device?.id}
                    type='DEVICE'
                />
            </HoverCopyCell>
        ),
    },
    {
        field: 'taskCheckAssigneeName',
        headerName: 'Người xử lý',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 200,
        renderCell: params => (
            <HoverCopyCell value={params.row?.taskCheck?.assigneeName}>
                <EntityDetailButton
                    text={params.row?.taskCheck?.assigneeName}
                    identifier={columnParams?.identifier}
                    entityId={params.row.taskCheck?.assigneeId}
                    type='ASSIGNEE'
                />
            </HoverCopyCell>
        ),
        excludeRoles: [RoleEnum.KTV],
    },
    {
        field: 'createdDate',
        headerName: 'Ngày tạo',
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 200,
        sortingOrder: ['asc', 'desc'],
        renderCell: params => (
            <HoverCopyCell value={dateUtils.getDate(params.row.createdDate)} />
        ),
    },
    {
        field: 'severityLevel',
        headerName: 'Mức độ',
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 200,
        renderCell: params => {
            const level = params.row.severityLevel;

            if (!level) {
                return '-:-';
            }

            return (
                <CustomChip
                    label={level.name}
                    size='small'
                    variant='tonal'
                    hexColorFromServer={level.color}
                />
            );
        },
    },
];
